import { rgb } from 'd3'

export const Colors = {
  sky: '#07b5e3',
  mint: '#00e08f',
  lemon: '#ffde02',
  coral: '#ff5c8d',

  black: '#000000',
  ink: '#101011',
  charcoal: '#242426',
  steel: '#3d3d40',
  midway: '#6d6c73',
  silver: '#a4a3a8',
  snow: '#f5f5f6',
  white: '#ffffff',
}

export const Fonts = {
  sansHeader: "'SF Display', 'Helvetica Neue', Helvetica, Arial, sans-serif",
  sansBody: "'SF UI Text', 'SF Text', 'Helvetica Neue', Helvetica, Arial, sans-serif",
  mono: "'SF Mono', monospace",
}

export type ColorName = keyof typeof Colors

export const ColorsRGB = {
  sky: rgb(Colors.sky),
  mint: rgb(Colors.mint),
  lemon: rgb(Colors.lemon),
  coral: rgb(Colors.coral),

  black: rgb(Colors.black),
  ink: rgb(Colors.ink),
  charcoal: rgb(Colors.charcoal),
  steel: rgb(Colors.steel),
  midway: rgb(Colors.midway),
  silver: rgb(Colors.snow),
  snow: rgb(Colors.snow),
  white: rgb(Colors.white),
}

export const LightColors = {
  sky: '#41d7ff',
  mint: '#0fffa7',
  lemon: '#ffea5e',
  coral: '#ff749e',

  black: Colors.ink,
  ink: Colors.charcoal,
  charcoal: Colors.steel,
  steel: Colors.midway,
  midway: Colors.silver,
  silver: Colors.snow,
  snow: Colors.white,
  white: Colors.white,
}

export const DarkColors = {
  sky: '#007e9e',
  mint: '#009d64',
  lemon: '#b0a508',
  coral: '#c14a6e',

  black: Colors.black,
  ink: Colors.black,
  charcoal: Colors.ink,
  steel: Colors.charcoal,
  midway: Colors.steel,
  silver: Colors.midway,
  snow: Colors.silver,
  white: Colors.snow,
}

export const Chars = {
  mDash: '—',
}

export const TZ_PACIFIC = 'America/Los_Angeles'
